/** @jsxImportSource @emotion/react */
import PropTypes from "prop-types";
import { flexRender } from "@tanstack/react-table";
import getCellStyles from "helpers/table/getCellStyles";
import TABLE_ROLES from "helpers/table/roles";
import { headerCellCss, trHeaderCss } from "./index.css";

export default function HeaderGroups({ getHeaderGroups }) {
  return (
    <div role={TABLE_ROLES.rowGroup} css={trHeaderCss}>
      {getHeaderGroups().map((headerGroup) => (
        <div key={headerGroup.id} role={TABLE_ROLES.row} className="flex">
          {headerGroup.headers.map(({ id, column, getSize, getContext }) => {
            const { sticky, header } = column.columnDef;
            const style = getCellStyles({ width: getSize(), sticky });

            return (
              <div
                key={id}
                role={TABLE_ROLES.columnHeader}
                css={headerCellCss}
                className="flex-a-c main-text-grey"
                style={style}
              >
                {flexRender(header, getContext())}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

HeaderGroups.propTypes = {
  getHeaderGroups: PropTypes.func.isRequired,
};
